import { makeAutoObservable, runInAction } from 'mobx';
import { client } from '../services/api';

export class CharityBannerStore {
  banners: any[] = [];
  totalItems = 0;
  isLoading = false;
  error: string | null = null;
  activeBannerIndex = 0;
  isVisible = true;

  constructor() {
    makeAutoObservable(this);
  }

  setBanners(banners: any[]) {
    this.banners = banners;
  }

  setTotalItems(totalItems: number) {
    this.totalItems = totalItems;
  }

  setLoading(loading: boolean) {
    this.isLoading = loading;
  }

  setError(error: any) {
    this.error = error;
  }

  fetchBanners = async () => {
    this.setLoading(true);
    this.setError(null);
    try {
      const response = await client.get('/CharityBanner/search?');
      runInAction(() => {
        this.setBanners(response.data.pageContent);
        this.setTotalItems(response.data.totalItems);
        this.setLoading(false);
      });
    } catch (error) {
      runInAction(() => {
        this.setLoading(false);
        this.setError(error);
      });
    }
  };

  async editBanner(bannerId: string, newData: any) {
    try {
      const response = await client.put(`/CharityBanner/${bannerId}`, newData);
      if (response.status !== 200) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      runInAction(() => {
        const index = this.banners.findIndex(banner => banner.id === bannerId);
        if (index !== -1) {
          this.banners[index] = response.data;
        }
      });
    } catch (error) {
      runInAction(() => {
        this.setError(error);
      });
    }
  }

  async deleteBanner(bannerId: string) {
    try {
      const response = await client.delete(`/CharityBanner/${bannerId}`);
      if (response.status !== 204) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      runInAction(() => {
        this.banners = this.banners.filter(banner => banner.id !== bannerId);
        if (this.activeBannerIndex >= this.banners.length) {
          this.activeBannerIndex = this.banners.length - 1;
        }
      });
    } catch (error) {
      runInAction(() => {
        this.setError(error);
      });
    }
  }
}
